import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {RoleService} from "../../../services/role.service";
import {BankTransferLoadService} from "../../../bank-transfer-load.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {BankTransferLoad, BankTransferLoadSourceRiskType, LoadTimeline} from "../../../dto/bankTransferLoad";
import {byNumeric} from "iso-country-codes";
import {Invoice} from "../../../dto/invoice";
import {
  DateFormats, formatPhone, formatPhoneNumeric, phoneToCountry,
  toCardExpireDateString,
  toDateString,
  toDateTimeString,
  toDateTimeStringNoSeconds
} from "../../../providers/app-date-adapter";
import {DatePipe} from "@angular/common";
import {CardsService} from "../../services/cards.service";
import {CustomersService} from "../../services/customers.service";
import {TrustPayService} from "../../../trust-pay.service";
import {
  BankTransferLoadTransaction,
  WhiteListedBankAccount,
  TrustPayTransaction, SelfLoadDeterminationModel
} from "../../../dto/trustPayTransaction";
import {Customer} from "../../../dto/customer";
import {Card} from "../../../dto/card";
import {Sofort} from "../../../dto/sofort";
import {Sepa} from "../../../dto/sepa";
import {AddressStatus, IdentLevel, IdentStatus} from "../../../dto/ident-status";
import {forkJoin, Observable} from "rxjs";
import {getTableFilters} from "../../../helpers/storage-helper";
import {PrevNextModel} from "../../../models/prev-next-model";
import {ObjectComment} from "../../../dto/object-comment";
import {ObjectCommentsService} from "../../services/object-comment.service";
import {EventLog} from "../../../dto/event-log";
import {EventLogService} from "../../../services/crud/event-log.service";
import {ConfirmDialogComponent} from "../../../shared/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ToastService} from "angular-toastify";
import {PHONE_MASK} from "../../../helpers/format-helpers";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CustomerEmailLogDto} from "../../../dto/customer-email-log-dto";
import {BankTransferRefundService} from "../../services/bank-transfer-refund.service";
import {MatPaginator} from "@angular/material/paginator";
import {CardHolderDetails} from "../../../dto/CardbroGateway/cardholder-details";
import {CardInfo} from "../../../dto/CardbroGateway/card-info";
import {CardbroGatewayService} from "../../services/cardbro-gateway.service";
import {Statement} from "../../../dto/CardbroGateway/statement";
import {Transaction} from "../../../dto/CardbroGateway/transaction";
import {MatTableDataSource} from "@angular/material/table";
import {CustomerRisk} from "../../../dto/customer-risk";
import {RiskOverviewService} from "../../services/risk-overview.service";
import {CityInfo} from "../../../dto/GeoIp/city-info";
import {GeoIpService} from "../../../services/geo-ip.service";
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {PepStatus} from "../../../dto/pep-status";
import {GpsCardStatus} from "../../../dto/gps-card-status";
import {PrevNextIdModel} from "../../../models/prev-next-id-model";
import {
  getIdentStatusColor,
  getIdentStatusIcon, getIdentStatusText,
  getPepStatusColor,
  getPepStatusText
} from "../../../helpers/pep-status-helper";
import * as moment from "moment";
import {ScaleType} from "@swimlane/ngx-charts";
import {LoadRiskFlags} from "../../../dto/loadRiskFlags";

@Component({
  selector: "app-btl-view",
  templateUrl: "./btl-view.component.html",
  styleUrls: ["./btl-view.component.css"]
})
export class BtlViewComponent implements OnInit, OnDestroy {
  public bankTransferLoad: BankTransferLoad | null;
  bankTransferLoadSourceRiskType = BankTransferLoadSourceRiskType;
  public gpsCardStatus = GpsCardStatus;
  currentGpsStatus: GpsCardStatus | null;
  public bankTransferLoadId: number | null;

  comments: ObjectComment[];
  commentsTarget = 5;
  logs: EventLog[];
  phoneMask = PHONE_MASK;


  webIdTransactionStatus = IdentStatus;


  // load timeline graph
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = true;
  legendTitle = "Legend";
  legendPosition = "right";
  showXAxisLabel = true;
  xAxisLabel = "Date";
  showYAxisLabel = true;
  yAxisLabel = "Amounts";
  showGridLines = true;
  innerPadding = "10%";
  animations: boolean = true;
  barPadding: number = 1;

  barCustomColors = [];


  colorScheme = {
    domain: ["#ad43d0", "#2e9fc7", "#f6a14a", "#8bc34a",]
  };
  view: any[] = [10000, 500];

  multi = [];


  // / load timeline graph


  prevNextIds: PrevNextIdModel | null;

  customer: Customer | null;
  trustPayTransaction: TrustPayTransaction | null;
  outboundTransactions: BankTransferLoadTransaction[] = [];
  whiteListedBankAccounts: WhiteListedBankAccount[] = [];

  isLoadingSelfLoadDetermination = false;
  selfLoadDetermination: SelfLoadDeterminationModel | null = null;

  loadHistory: BankTransferLoad[] | null;
  sofortHistory: Sofort[] | null;
  sepaHistory: Sepa[] | null;
  private busyPollerInterval: ReturnType<typeof setTimeout> | null;
  wasBusy = false;
  isBusy = false;
  _isSendingSofSingle = false;
  _isRequestingIdent = false;
  _isSendingPoa = false;

  sourceList: BtlSourceList = BtlSourceList.Pending;
  fromParam: string | null = null;

  customerRisk: CustomerRisk | null;
  isLoadingRisk = false;
  ipCityInfo: CityInfo | null;
  maxDailyLoad = 0;

  identStatus = IdentStatus;
  pepStatus = PepStatus;
  identLevel = IdentLevel;
  addressStatus = AddressStatus;
  isApprovingLoad = false;
  isDecliningLoad = false;
  isExecutingLoad = false;
  loadTimeline: LoadTimeline | null = null;
  private nowInterval: ReturnType<typeof setTimeout> | null;
  instantLoadDelayedUntilMoment: moment.Moment | null;

  constructor(
    private _toastService: ToastService,
    private roleService: RoleService,
    private bankTransferLoadService: BankTransferLoadService,
    private bankTransferRefundService: BankTransferRefundService,
    private cardService: CardsService,
    private customersService: CustomersService,
    private trustPayService: TrustPayService,
    private router: Router,
    private route: ActivatedRoute,
    public datePipe: DatePipe,
    private objectCommentsService: ObjectCommentsService,
    private logService: EventLogService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private cardbroGatewayService: CardbroGatewayService,
    private cardsService: CardsService,
    private riskOverviewService: RiskOverviewService,
    private geoIpService: GeoIpService
  ) {
  }

  /*fields = [
    // { header: "Code", cell: (row: Invoice) => `${row.code}` },

    { header: "Date", cell: (row: BankTransferLoad) => `${ this.datePipe.transform( row.createDate, DateFormats.DisplayDateTime ) }` },
    { header: "Amount", cell: (row: BankTransferLoad) => `${row.amount}` },
    { header: "Description", cell: (row: BankTransferLoad) => `${row.description}` },
    { header: "Load fee", cell: (row: BankTransferLoad) => `${row.loadFee}` },
    { header: "Card", cell: (row: BankTransferLoad) => `${row.card.token}` },
    { header: "Risk level", cell: (row: BankTransferLoad) => `${row.riskLevel}` },
    { header: "Risk info", cell: (row: BankTransferLoad) => `${row.riskLevelAutomaticComment}` },
    { header: "Approved automatically", cell: (row: BankTransferLoad) => `${row.isApprovedAutomatically}` },
    { header: "Approved manually", cell: (row: BankTransferLoad) => `${row.isApprovedManually}` },
    { header: "Needs manual approval", cell: (row: BankTransferLoad) => `${row.needsManualApproval}` },


  ];*/

  fieldsTransaction = [
    {
      columnDef: "createDate",
      header: "Created / Statement",
      cell: (row: TrustPayTransaction) => `${toDateTimeStringNoSeconds(row.createDate) || ""} / ${toDateString(row.statementDate) || ""}`
    },
    {
      columnDef: "source", header: "Source", cell: (row: TrustPayTransaction) => {
        switch (row.source) {
          case 0 :
            return "Revolut";
          case 1 :
            return "Trustpay";
          case 2 :
            return "Qonto";
          case 3 :
            return "Commerzbank";
          case 4 :
            return "MicroPayment";
          case 5 :
            return "Moorwand";
        }
        return "Unknown";
      }
    },
    {columnDef: "amount", header: "Amount", cell: (row: TrustPayTransaction) => `${row.amount.formatMoneyEuro()}`},
    {
      columnDef: "reference",
      header: "Reference",
      cell: (row: TrustPayTransaction) => `${row.reference || "(missing)"}`
    },
    {
      columnDef: "description",
      header: "Description",
      cell: (row: TrustPayTransaction) => `${row.description || "(missing)"}`
    },
    {
      columnDef: "counterAccount",
      header: "Counter Account",
      cell: (row: TrustPayTransaction) => `${row.counterAccountMasked || row.counterAccount} / ${row.counterAccountName}`
    },
    {
      columnDef: "card",
      header: "Linked Card",
      cell: (row: TrustPayTransaction) => `${row.cardFound ? row.cardFound.token : "-"}`
    },

  ];

  fieldsGpsTransaction = [
    {
      columnDef: "createDate",
      header: "Created",
      cell: (row: BankTransferLoadTransaction) => `${toDateTimeString(row.transactionDate) || ""}`
    },
    {columnDef: "type", header: "Type", cell: (row: BankTransferLoadTransaction) => `${row.type}`},
    {
      columnDef: "amount",
      header: "Amount",
      cell: (row: BankTransferLoadTransaction) => `${row.amountLoaded.formatMoneyEuro()}`
    },
    {columnDef: "status", header: "Status", cell: (row: BankTransferLoadTransaction) => `${row.lastGpsStatus || ""}`},

  ];

  fieldsCustomer = [
    {header: "Title", cell: (row: Customer) => `${row.title}`},
    {header: "First name", cell: (row: Customer) => `${row.firstName || ""}`} as ContentRowField<Customer>,
    {header: "Last name", cell: (row: Customer) => `${row.lastName || ""}`} as ContentRowField<Customer>,
    {header: "Address", cell: (row: Customer) => `${row.address || ""}`} as ContentRowField<Customer>,
    {header: "City", cell: (row: Customer) => `${row.city || ""}`} as ContentRowField<Customer>,
    {header: "Zip code", cell: (row: Customer) => `${row.zipCode || ""}`} as ContentRowField<Customer>,
    {header: "Email", cell: (row: Customer) => `${row.email || ""}`} as ContentRowField<Customer>,
    {header: "Phone", cell: (row: Customer) => `${row.phone || ""}`} as ContentRowField<Customer>,
    {header: "Date of birth", cell: (row: Customer) => `${toDateString(row.dob) || ""}`} as ContentRowField<Customer>,
    {
      header: "Country",
      cellFlag: (row: Customer) => byNumeric[row.countryIsoCode.toString().padStart(3, "0")].alpha2 || null,
      cell: (row: Customer) => `${row.countryName || ""}`
    } as ContentRowField<Customer>,
    {
      header: "IP Address", cellFlag: (row: Customer) => this.ipCityInfo?.countryAlphaIsoCode || null
      , cell: (row: Customer) => {
        const ret = row.ipAddress || "";
        if (ret && this.ipCityInfo) {
          //ret += " (" + this.ipCityInfo.postCode + " " + this.ipCityInfo.city + " " + this.ipCityInfo.countryName + ")"
        }
        return ret;

      }
    } as ContentRowField<Customer>,


    {
      header: "Ident",
      iconColor: row => getIdentStatusColor(row.identStatus),
      icon: (row: Customer) => getIdentStatusIcon(row.identStatus),
      cell: row => getIdentStatusText(row.identStatus),
    } as ContentRowField<Customer>,
    {
      header: "PEP Status",
      iconColor: (row: Customer) => getPepStatusColor(row.pepStatus), icon: (row: Customer) => "perm_identity",
      cell: (row: Customer) => getPepStatusText(row.pepStatus),
    },
    {
      header: "Address Status",
      iconColor: (row: Customer) => {

        if (row.addressStatus == AddressStatus.Confirmed) {
          return "#8bc34a";
        }
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
          return "#4a82c3";
        }
        if (row.addressStatus == AddressStatus.PendingCheck) {
          return "#684ac3";
        }

        return "#d04848";
      },
      icon: (row: Customer) => {
        if (row.addressStatus == AddressStatus.Confirmed) {
          return "place";
        }
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
          return "not_listed_location";
        }
        if (row.addressStatus == AddressStatus.PendingCheck) {
          return "not_listed_location";
        }

        return "not_listed_location";
      }, cell: (row: Customer) => {
        if (row.addressStatus == AddressStatus.Confirmed) {
          return "Confirmed";
        }
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
          return "Waiting for documents";
        }
        if (row.addressStatus == AddressStatus.PendingCheck) {
          return "Pending check";
        }

        return "Unconfirmed";
      }
    },


    {
      header: "Docs",
      cell: (row: Customer) => `${row.docsSuccess ? "OK" : "missing or declined"}`
    } as ContentRowField<Customer>,
    {
      header: "IDV",
      cell: (row: Customer) => `${row.idvSuccess ? "OK" : "missing or declined"}`
    } as ContentRowField<Customer>,
  ] as ContentRowField<Customer>[];

  fieldsCard = [
    {header: "Card name", cell: (row: Card) => `${row.cardName || ""}`},
    {header: "Status", cell: (row: Card) => `${row.statusName || ""}`},
    {header: "Exp date", cell: (row: Card) => `${toCardExpireDateString(row.expireDate) || ""}`},
    {header: "Token", cell: (row: Card) => `${row.token}`},
    {header: "Product", cell: (row: Card) => `${row.productName}`},
    {header: "Creation Date", cell: (row: Card) => `${toDateTimeString(row.creationDate) || ""}`},
    {header: "Activation date", cell: (row: Card) => `${toDateTimeString(row.activationDate) || ""}`},
    {header: "Order date", cell: (row: Card) => `${toDateString(row.orderDate) || ""}`},
    // <a route_to_page search_string information_to_display
    {header: "PAN", cell: (row: Card) => `${row.maskedPAN || "(unknown)"}`},
    {header: "Card Type", cell: (row: Card) => `${row.cardTypeName || "(unknown)"}`},
  ];
  isLoading = false;
  loadHistorySum = 0;
  loadHistoryPendingSum = 0;


  smsForm: FormGroup;
  pushForm: FormGroup;
  isSmsSending = false;
  isPushSending = false;
  smsEmailLogs: CustomerEmailLogDto[];

  // card enquiry

  cards = [] as
    {
      id: number;
      card: Card;
      editVisible: boolean;
      editForm: FormGroup;
      invoiceComments: ObjectComment[];
      statement: Statement;
      financialStatements: any;
      cardholderDetails: CardHolderDetails;
      cardInfo: CardInfo;
    }[];

  @ViewChild(MatPaginator, {static: false}) paginatorStatement: MatPaginator;

  isStatementLoading = false;
  isCardInfoLoading = false;
  isCardholderDetailsLoading = false;

  displayedStatementColumns: string[] = ["direction", "transactionDate", "description", "amount", "blockAmount", "billAmount", "currency", "rateFee", "fixedFee", "statusDescription"];

  fieldsCardholderDetails = [
    {header: "Sex", cell: (row: CardHolderDetails) => `${row.sex}`},
    {header: "Firstname", cell: (row: CardHolderDetails) => `${row.firstName}`},
    {header: "Lastname", cell: (row: CardHolderDetails) => `${row.lastName}`},
    {header: "E-Mail", cell: (row: CardHolderDetails) => `${row.email}`},
    {header: "Date of birth", cell: (row: CardHolderDetails) => `${toDateString(row.dateOfBirth) || ""}`},
    {header: "Mobile", cell: (row: CardHolderDetails) => `${formatPhone(row.phone)}`},
    {
      header: "Mobile",
      cellFlag: (row: CardHolderDetails) => phoneToCountry(row.mobile),
      cell: (row: CardHolderDetails) => `${row.mobile}`
    },
    {header: "Address Line 1", cell: (row: CardHolderDetails) => `${row.addrl1}`},
    {header: "Address Line 2", cell: (row: CardHolderDetails) => `${row.addrl2}`},
    {header: "Zip City", cell: (row: CardHolderDetails) => `${row.postCode} ${row.city}`},
  ];

  fieldsCardInfo = [
    {header: "Status", cell: (row: CardInfo) => `${row.statusText}`},
    {header: "PAN", cell: (row: CardInfo) => `${row.maskedPAN}`},
    {header: "Embossed name", cell: (row: CardInfo) => `${row.embossedName}`},
    {header: "Creation", cell: (row: CardInfo) => `${toDateString(row.creationDate) || ""}`},
    {header: "Expiry", cell: (row: CardInfo) => `${toDateString(row.expiryDate) || ""}`},
    {header: "Avail. balance", cell: (row: CardInfo) => `${row.currency} ${row.availableBalance}`},
    {header: "Blocked amount", cell: (row: CardInfo) => `${row.currency} ${row.blockedAmount}`},
    // { header: "Currency", cell: (row: CardInfo) => `${row.currency}` },
    {header: "Product", cell: (row: CardInfo) => `${row.product}`},
    {header: "Limit group", cell: (row: CardInfo) => `${row.limitGroupDesc}`},


  ];

  // / card enquiry


  ngOnInit() {

    this.barCustomColors.push({"name": moment().format("YYYY-MM-DD"), "value": "#ff0000"});

    this.startIsBusyCheck();

    this.nowInterval = setInterval(() => { this.now = moment(); }, 30000);

    this.route.params.subscribe((params: Params) => {

      this.bankTransferLoad = null;
      this.isLoading = true;

      const id = parseInt(this.route.snapshot.paramMap.get("id"));
      this.bankTransferLoadId = id;
      this.loadBankTransferLoad(id);

      this.fromParam = this.route.snapshot.queryParamMap.get("f");
      if (this.fromParam === "refund") {
        this.sourceList = BtlSourceList.Refund;
      } else if (this.fromParam == "refund-history") {
        this.sourceList = BtlSourceList.RefundHistory;
      } else if (this.fromParam == "pre-approved") {
        this.sourceList = BtlSourceList.PreApproved;
      } else if (this.fromParam == "history") {
        this.sourceList = BtlSourceList.LoadHistory;
      } else if (this.fromParam == "delayed") {
        this.sourceList = BtlSourceList.Delayed;
      } else {
        this.sourceList = BtlSourceList.Pending;
      }

      this.getPrevNext(this.bankTransferLoadId);


    });

  }


  ngOnDestroy() {
    if (this.busyPollerInterval) {
      clearInterval(this.busyPollerInterval);
    }
    if (this.nowInterval) {
      clearInterval(this.nowInterval);
    }
  }

  initSmsForm(customer: Customer) {
    // console.log(customer);
    const message = this.smsForm != null && this.smsForm.value ? this.smsForm.value.message : "";

    this.smsForm = this.formBuilder.group({
      mobile: customer.phone != null ? customer.phone.toString() : null,
      message,
      customerId: customer.id
    });
  }

  initPushForm(customer: Customer) {
    this.pushForm = this.formBuilder.group({
      isSilent: false,
      notificationTitle: '',
      severity: 'info',
      notificationText: '',
      bodyTitle: '',
      bodyText: '',
      customerId: customer.id,
      dataString: '',
    });
  }

  onSendSms(form: FormGroup) {


    this.isSmsSending = true;
    this.customersService.sendSMS(form.value).subscribe(res => {
        this.smsForm.controls["message"].patchValue("");
        this.showMessage("message sent");
        this.reloadEmailSmsLog(this.customer.id);
        this.isSmsSending = false;
      },
      err => {
        this.showMessage(err.error.Message);
        this.isSmsSending = false;
      }
    );

  }

  splitFirstInstance(str: string, item: string): string[] {
    const res = [];
    let found = true;
    res.push("");
    for (let i = 0; i < str.length; i++) {
      if (str[i] === item && found === true) {
        res.push("");
        found = false;
      } else {
        res[res.length - 1] += str[i];
      }
    }
    return res;
  }

  onSendPush(form: FormGroup) {


    this.isPushSending = true;

    const dataString = this.pushForm.get("dataString").value as string;
    const lines = dataString.split(/\r?\n/);
    const data: { [key: string]: string } = {};
    lines.forEach(line => {
      const d = this.splitFirstInstance(line, "=");
      data[d[0]] = d[1];
    });

    const fs = form.value;
    fs.data = data;

    this.customersService.sendPush(fs).subscribe(pushRes => {
        //this.initPushForm(this.customer);
        this._toastService.success("Push was sent to " + pushRes.okTokens + " devices");
        this.reloadEmailSmsLog(this.customer.id);
        this.isPushSending = false;
      },
      err => {
        this._toastService.error(err.error.Message);
        this.isPushSending = false;
      }
    );

  }

  reloadEmailSmsLog(id: number) {
    this.customersService.getCustomerEmailLogs(id).subscribe(result => {

      const onlySmsLogs = [];

      result.forEach(log => {
        // sms
        if (log.emailType == 15) {
          onlySmsLogs.push(log);
        }
      });

      this.smsEmailLogs = onlySmsLogs;
    });
  }


  startIsBusyCheck() {
    if (this.busyPollerInterval) {
      clearInterval(this.busyPollerInterval);
      this.busyPollerInterval = null;
    }
    this.checkIsBusy();
    this.busyPollerInterval = setInterval(() => this.checkIsBusy(), 5000);
  }

  busyFalseCount = 0;

  checkIsBusy() {
    this.trustPayService.getIsBusy()
      .subscribe(result => {
        this.isBusy = result;
        console.log("busy: " + this.isBusy);

        if ( this.isBusy )
          this.busyFalseCount = 0;
        if ( !this.isBusy )
          this.busyFalseCount++;


        if (this.isBusy != this.wasBusy || (!this.isBusy && this.busyFalseCount > 10)) {
          this.wasBusy = this.isBusy;
          clearInterval(this.busyPollerInterval);
          this.busyPollerInterval = null;
          this.loadBankTransferLoad(this.bankTransferLoadId);

        }
      });
  }


  currentUserIsIssuerExternal(): boolean {
    return this.roleService.hasRoles(["issuer_external"]);
  }

  returnBack() {

    if (this.currentUserIsIssuerExternal()) {
      this.router.navigate(["/customers-overview/" + this.customer.id], {relativeTo: this.route});
    }


    switch (this.sourceList) {
      case BtlSourceList.Pending:
        this.router.navigate([".."], {relativeTo: this.route}); // TODO go to pending tab
        break;
      case BtlSourceList.PreApproved:
        this.router.navigate([".."], {relativeTo: this.route}); // TODO go to preapproved tab
        break;
      case BtlSourceList.LoadHistory:
        this.router.navigate(["/loads/btl/gps-load-response/history"], {relativeTo: this.route}).then();
        break;
      case BtlSourceList.Refund:
        this.router.navigate(["/loads/btl/load-refunds/list"], {relativeTo: this.route}).then();
        break;
      case BtlSourceList.RefundHistory:
        this.router.navigate(["/loads/btl/load-refunds/history"], {relativeTo: this.route}).then();
        break;
      case BtlSourceList.Delayed:
        this.router.navigate([".."], {relativeTo: this.route}); // TODO go to delayed tab
        break;

    }

  }

  getCardholderDetails(card) {

    // test: "125130184"
    this.isCardholderDetailsLoading = true;

    this.cardbroGatewayService.getCardholderDetails(card.card.token).subscribe(data => {
        card.cardholderDetails = data;
        this.isCardholderDetailsLoading = false;
      },
      err => {
        this.showMessage(err.error.message || err.error || err.message);
        this.isCardholderDetailsLoading = false;
      });


  }

  getCardInfos(card) {


    this.isCardInfoLoading = true;

    this.cardbroGatewayService.getCardInfo(card.card.token).subscribe(data => {
        card.cardInfo = data;
        this.isCardInfoLoading = false;
      },
      err => {
        this.showMessage(err.error.message || err.error || err.message);
        this.isCardInfoLoading = false;
      });


  }


  goToEdit() {

  }

  isAdmin() {
    return this.roleService.hasRoles(["admin"]);
  }

  isCompliance() {
    return this.roleService.hasRoles(["compliance_manager"]);
  }

  private loadBankTransferLoad(id: number) {
    this.isLoading = true;
    this.bankTransferLoadService.get(id).subscribe(data => {
      this.isLoading = false;
      this.bankTransferLoad = data;
      this.currentGpsStatus = this.bankTransferLoad.card.gpsCardStatus;

      this.isDelayedNow = this.bankTransferLoad.delayedIndefinitely || this.bankTransferLoad.delayNextLoadUntil && moment(this.bankTransferLoad.delayNextLoadUntil).isAfter();
      this.cannotExecuteYet = this.bankTransferLoad.executionNotBefore && moment(this.bankTransferLoad.executionNotBefore).isAfter();
      if ( this.bankTransferLoad.instantLoadDelayedUntil)
        this.instantLoadDelayedUntilMoment = moment(this.bankTransferLoad.instantLoadDelayedUntil)
      else this.instantLoadDelayedUntilMoment = null;

      this.loadOutboundTransactions();
      this.loadMaxDailyLoad(this.bankTransferLoadId);

      if (this.bankTransferLoad.trustPayTransactionId) {
        this.loadTransaction(this.bankTransferLoad.trustPayTransactionId);
      } else {
        this.trustPayTransaction = null;
      }

      if (this.bankTransferLoad.card != null) {
        this.loadCustomer(this.bankTransferLoad.card.customerId);
        this.loadLoadHistory(this.bankTransferLoad.card.id, this.bankTransferLoad.card.customerId);


        this.loadLoadTimeline(this.bankTransferLoad.card.token);
        this.loadSelfLoadDetermination();

      } else {
        this.loadHistory = [];
      }

    });

    if (!this.currentUserIsIssuerExternal()) {
      this.objectCommentsService.getForObject(this.bankTransferLoadId, this.commentsTarget).subscribe(data => {
        this.comments = data;
      });
    }

    this.logService.get(23, this.bankTransferLoadId).subscribe(data => {
      this.logs = data;
    });

  }

  isComplianceOrFinance() {
    return this.roleService.hasRoles(["compliance", "admin", "compliance_manager", "finance_manager"]);
  }

  isComplianceManager() {
    return this.roleService.hasRoles(["compliance_manager"]);
  }

  hasWritePermissions() {
    return this.roleService.hasRoles(["admin", "finance_manager"]);
  }

  approveLoad() {
    this.isApprovingLoad = true;
    this.isBusy = true;
    this.bankTransferLoadService.approveLoad(this.bankTransferLoad.id).subscribe(data => {
      this.loadBankTransferLoad(this.bankTransferLoadId);
      this.isApprovingLoad = false;
      this.isBusy = false;
    }, error => {
      this.isApprovingLoad = false;
      this.isBusy = false;
    });

    return false;
  }

  requestSof() {
    this._isSendingSofSingle = true;
    this.bankTransferLoadService.requestSof(this.bankTransferLoad.id).subscribe(data => {
      this.loadBankTransferLoad(this.bankTransferLoadId);
      this._isSendingSofSingle = false;
    }, err => {
      this._isSendingSofSingle = false;
    });
    return false;
  }


  requestPoa() {
    this._isSendingPoa = true;
    this.bankTransferLoadService.requestPoa(this.bankTransferLoad.id).subscribe(data => {
      this.loadBankTransferLoad(this.bankTransferLoadId);
      this._isSendingPoa = false;
    }, err => {
      this._isSendingPoa = false;
    });
    return false;
  }


  executeLoad() {

    let amountToLoadNow = this.bankTransferLoad.amountToLoad - this.bankTransferLoad.amountAlreadyLoaded;

    if (this.maxDailyLoad === 0) {

      this.showError("Max daily load is undetermined");
      return;
    }

    const maxAmount = this.maxDailyLoad;


    if (amountToLoadNow > maxAmount) {
      amountToLoadNow = maxAmount;
    }

    // query this from backend

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Load card",
        text: "Are you sure you want to load card " + this.bankTransferLoad.card.token + " by " + amountToLoadNow + " " + this.bankTransferLoad.card.product.currCode + "?"
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result == "ok") {
          this.isExecutingLoad = true;
          this.isBusy = true;
          this.bankTransferLoadService.executeLoad(this.bankTransferLoad.id).subscribe(data => {
            this.showSuccess("Card " + this.bankTransferLoad.card.token + " has been loaded by " + amountToLoadNow);
            this.loadBankTransferLoad(this.bankTransferLoadId);
            this.isBusy = false;
            this.isExecutingLoad = false;
          }, err => {

            this.showError(err.error.message || err.error || err.message || err);
            this.isExecutingLoad = false;
            this.isBusy = false;
          });

        }
      });


    return false;
  }

  executeG3Load() {

    let amountToLoadNow = this.bankTransferLoad.amountToLoad - this.bankTransferLoad.amountAlreadyLoaded;

    if (this.maxDailyLoad === 0) {

      this.showError("Max daily load is undetermined");
      return;
    }

    const maxAmount = this.maxDailyLoad;


    if (amountToLoadNow > maxAmount) {
      amountToLoadNow = maxAmount;
    }

    // query this from backend

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Load G3 card",
        text: "Are you sure you want to load card " + this.bankTransferLoad.card.token + " by " + amountToLoadNow + " " + this.bankTransferLoad.card.product.currCode + "? The card will be unlocked, loaded and immediately locked again"
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result == "ok") {
          this.isExecutingLoad = true;
          this.isBusy = true;
          this.bankTransferLoadService.executeG3Load(this.bankTransferLoad.id).subscribe(data => {
            this.showSuccess("Card " + this.bankTransferLoad.card.token + " has been loaded by " + amountToLoadNow);
            this.loadBankTransferLoad(this.bankTransferLoadId);
            this.isBusy = false;
            this.isExecutingLoad = false;
          }, err => {

            this.showError(err.error.message || err.error || err.message || err);
            this.isExecutingLoad = false;
            this.isBusy = false;
          });

        }
      });


    return false;
  }


  holdLoad() {
    this.isBusy = true;
    this.bankTransferLoadService.holdLoad(this.bankTransferLoad.id).subscribe(data => {
      this.isBusy = false;
      this.loadBankTransferLoad(this.bankTransferLoadId);
    });
  }

  refundLoad() {
    this.isBusy = true;
    this.bankTransferRefundService.refundLoad(this.bankTransferLoad.id).subscribe(data => {
      this.isBusy = false;
      this.loadBankTransferLoad(this.bankTransferLoadId);
    });
  }

  confirmLoadManually() {
    this.isBusy = true;
    this.bankTransferLoadService.confirmLoadManually(this.bankTransferLoad.id).subscribe(data => {
      this.isBusy = false;
      this.loadBankTransferLoad(this.bankTransferLoadId);
    });
  }

  markLoadForRefund() {
    this.isBusy = true;
    this.bankTransferLoadService.markForRefund(this.bankTransferLoad.id).subscribe(data => {
      this.isBusy = false;
      this.loadBankTransferLoad(this.bankTransferLoadId);
    });
  }


  declineLoad() {
    this.bankTransferLoadService.declineLoad(this.bankTransferLoad.id).subscribe(data => {
      this.loadBankTransferLoad(this.bankTransferLoadId);
    });
  }

  recalcLoad() {
    this.isLoading = true;
    this.bankTransferLoadService.recalcLoad(this.bankTransferLoad.id).subscribe(data => {
      this.isLoading = false;
      this.loadBankTransferLoad(this.bankTransferLoadId);
    });
  }

  private loadTransaction(transactionId: number) {
    this.isLoading = true;
    this.trustPayService.get(transactionId).subscribe(data => {
      this.trustPayTransaction = data;
      this.isLoading = false;
    });
  }

  private loadCustomer(customerId: number) {
    this.customersService.get(customerId).subscribe(data => {
      this.customer = data;

      if (this.customer.ipAddress) {
        this.geoIpService.getCityByIp(this.customer.ipAddress).subscribe(city => this.ipCityInfo = city, err => {
        });
      }

      this.cardsService.getForCustomer(this.customer.id).subscribe(data => {
        this.cards = [];
        data.forEach(card => {
          this.cards.push({
            card,
            id: card.id,
            cardholderDetails: null,
            cardInfo: null,
            financialStatements: [],
            editForm: null,
            editVisible: false,
            invoiceComments: [],
            statement: null,
          });
        });
      });
      this.initSmsForm(this.customer);
      this.initPushForm(this.customer);
      this.reloadEmailSmsLog(customerId);

      this.isLoadingRisk = true;
      this.riskOverviewService.get(this.customer.id).subscribe(data => {
        this.customerRisk = data;
        this.isLoadingRisk = false;
      });

      this.loadCustomerAllowedBankAccounts();

    });
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(["partner", "partner_support"]);
  }

  isGpsButtonEnabled() {
    //const ok = this.roleService.hasRoles(["admin", "manager", "compliance"]);

    if (this.roleService.hasRoles(["partner", "partner_support"])) {
      return false;
    }
    return true;

  }

  getStatement(card) {

    this.isStatementLoading = true;
    this.cardbroGatewayService.getStatementEhi(card.card.token).subscribe(data => {
        card.statement = data;


        if (card.statement != null && card.statement.financialTransactions != null && card.statement.financialTransactions.length > 0) {

          card.statement.financialTransactions.forEach((item: Transaction) => {
            if (item.isCredit) {

            }

            if (item.isDebit) {
              item.amount = item.amount * -1;
              //item.billAmount = item.billAmount * -1;
            }

            item.description = item.description.replace(/\\/g, "\n");
            if (item.note === item.description) {
              item.note = null;
            }

            if (item.statusDescription == "AuthorizationReversed") {
              item.statusDescription = "Auth. Reversed";
            }


          });
        }


        card.financialStatements = new MatTableDataSource<Transaction>(card.statement.financialTransactions);
        card.financialStatements.paginator = this.paginatorStatement;
        this.isStatementLoading = false;
        // console.log( data.financialTransactions );
      },
      err => {
        this.showMessage(err.error.message || err.error || err.message);
        this.isStatementLoading = false;
      }
    );
  }

  private loadOutboundTransactions() {
    this.bankTransferLoadService.getOutboundTransactions(this.bankTransferLoadId).subscribe(data => {
      this.outboundTransactions = data;
    });
  }

  private loadCustomerAllowedBankAccounts() {
    this.isLoadingWhiteListedBankAccounts = true;
    this.customersService.getCustomerWhiteListedBankAccounts(this.customer.id).subscribe(data => {
      this.whiteListedBankAccounts = data;
      this.isLoadingWhiteListedBankAccounts = false;
    });

  }

  private loadSelfLoadDetermination() {
    this.isLoadingSelfLoadDetermination = true;
    this.selfLoadDetermination = null;
    this.bankTransferLoadService.getSelfLoadDetermination(this.bankTransferLoadId).subscribe(data => {
      this.selfLoadDetermination = data;
      this.isLoadingSelfLoadDetermination = false;
    });

  }

  private loadMaxDailyLoad(bankTransferLoadId: number) {
    this.bankTransferLoadService.getMaxDailyLoad(bankTransferLoadId).subscribe(d => {
      this.maxDailyLoad = d;
    });
  }

  private loadLoadTimeline(publicToken: string) {
    this.bankTransferLoadService.getLoadTimeline(publicToken).subscribe(tl => {
      this.loadTimeline = tl;
      this.generateLoadTimelineGraphData();


    });
  }

  private loadLoadHistory(cardId: number, customerId: number) {

    forkJoin(
      this.bankTransferLoadService.getCustomerLoads(customerId),
      this.bankTransferLoadService.getSoforts(cardId),
      this.bankTransferLoadService.getSepas(cardId),
    ).subscribe(([loads, soforts, sepas]) => {
      this.loadHistory = loads;
      this.sofortHistory = soforts;
      this.sepaHistory = sepas;

      const oneYearAgo = new Date();
      oneYearAgo.setDate(oneYearAgo.getDate() - 365);

      let loadSum = 0;
      let loadPendingSum = 0;
      this.loadHistory.forEach(ele => {
        const ohDate = new Date(ele.statementDate);
        if (ohDate < oneYearAgo) {
          return;
        }


        loadSum += ele.amountAlreadyLoaded;
        loadPendingSum += ele.isMarkedForRefund || ele.isRefunded ? 0 : (ele.amountToLoad - ele.amountAlreadyLoaded);

      });
      this.sofortHistory.forEach(ele => {
        const ohDate = new Date(ele.statementDate);
        if (ohDate < oneYearAgo) {
          return;
        }

        loadSum += ele.statementAmount;
      });
      this.sepaHistory.forEach(ele => {
        const ohDate = new Date(ele.date);
        if (ohDate < oneYearAgo) {
          return;
        }
        loadSum += ele.amount;
      });
      this.loadHistorySum = Math.round(loadSum * 100) / 100;
      this.loadHistoryPendingSum = Math.round(loadPendingSum * 100) / 100;

    });

    /*this.bankTransferLoadService.getLoads(cardId).subscribe(data => {
      this.loadHistory = data;
    });
    this.bankTransferLoadService.getSoforts(cardId).subscribe(data => {
      this.sofortHistory = data;
    });
    this.bankTransferLoadService.getSepas(cardId).subscribe(data => {
      this.sepaHistory = data;
    });*/

  }


  getTableFilters() {
    return getTableFilters("bankTransferLoadTable");
  }

  getPrevNext(id: number) {
    const filters = this.getTableFilters();
    // console.log(filters);

    switch (this.sourceList) {
      case BtlSourceList.Pending:
        this.bankTransferLoadService.getPrevNextPending(filters, id).subscribe(result => {
          this.prevNextIds = result;
        });
        break;
      case BtlSourceList.PreApproved:
        this.bankTransferLoadService.getPrevNextPreApproved(filters, id).subscribe(result => {
          this.prevNextIds = result;
        });
        break;
      case BtlSourceList.LoadHistory:
        this.bankTransferLoadService.getPrevNextLoadHistory(filters, id).subscribe(result => {
          this.prevNextIds = result;
        });
        break;
      case BtlSourceList.Refund:
        this.bankTransferLoadService.getPrevNextRefund(filters, id).subscribe(result => {
          this.prevNextIds = result;
        });
        break;
      case BtlSourceList.RefundHistory:
        this.bankTransferLoadService.getPrevNextRefundHistory(filters, id).subscribe(result => {
          this.prevNextIds = result;
        });
        break;
      case BtlSourceList.Delayed:
        this.bankTransferLoadService.getPrevNextDelayed(filters, id).subscribe(result => {
          this.prevNextIds = result;
        });
        break;

    }

  }

  gotoPrev() {
    this.isLoading = true;
    const filters = this.getTableFilters();

    switch (this.sourceList) {
      case BtlSourceList.Pending:
        this.bankTransferLoadService.getPrevNextPending(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.prevId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.PreApproved:
        this.bankTransferLoadService.getPrevNextPreApproved(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.prevId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.LoadHistory:
        this.bankTransferLoadService.getPrevNextLoadHistory(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.prevId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.Refund:
        this.bankTransferLoadService.getPrevNextRefund(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.prevId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.RefundHistory:
        this.bankTransferLoadService.getPrevNextRefundHistory(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.prevId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.Delayed:
        this.bankTransferLoadService.getPrevNextDelayed(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.prevId], {queryParams: {f: this.fromParam}}).then();
        });
        break;

    }

  }

  gotoNext() {
    this.isLoading = true;
    const filters = this.getTableFilters();

    switch (this.sourceList) {
      case BtlSourceList.Pending:
        this.bankTransferLoadService.getPrevNextPending(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.nextId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.PreApproved:
        this.bankTransferLoadService.getPrevNextPreApproved(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.nextId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.LoadHistory:
        this.bankTransferLoadService.getPrevNextLoadHistory(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.nextId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.Refund:
        this.bankTransferLoadService.getPrevNextRefund(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.nextId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.RefundHistory:
        this.bankTransferLoadService.getPrevNextRefundHistory(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.nextId], {queryParams: {f: this.fromParam}}).then();
        });
        break;
      case BtlSourceList.Delayed:
        this.bankTransferLoadService.getPrevNextDelayed(filters, this.bankTransferLoadId).subscribe(result => {
          this.router.navigate(["/loads/btl/" + result.nextId], {queryParams: {f: this.fromParam}}).then();
        });
        break;

    }
  }

  gotoNextPending() {
    const filters = this.getTableFilters();
    this.bankTransferLoadService.getNextPending(filters, this.bankTransferLoadId).subscribe(result => {
      this.router.navigate(["/loads/btl/" + result]);
    });
  }


  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ["app-mat-snack-bar"]
    });
  }

  showSuccess(message) {
    this._toastService.success(message);
  }

  showInfo(message) {
    this._toastService.info(message);
  }

  showError(message) {
    this._toastService.error(message);
  }

  unlinkTransactionFromBtl() {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Unlink card",
        text: "Are you sure you want to unlink the card? The load will be removed and the transaction will need to be re-assigned."
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result == "ok") {
          this.isBusy = true;
          this.trustPayService.unlinkTransactionFromCard(this.bankTransferLoad.trustPayTransactionId, this.bankTransferLoad.trustPayTransaction.cardFoundId).subscribe(result => {
              this.isBusy = false;

              this.returnBack();
            }, err => {
              this.isBusy = false;
              this.showError(err.error.message || err.error || err.message);
            }
          );
        }
      });


  }

  permissionRecalc() {
    return this.isComplianceOrFinance() || this.hasWritePermissions() || this.isAdmin();
  }

  permissionConfirmIfExported() {
    return this.isComplianceOrFinance() || this.hasWritePermissions() || this.isAdmin();
  }

  permissionConfirmNotExported() {
    return this.isAdmin() || this.hasWritePermissions();
  }

  permissionMarkForRefund() {
    return this.isAdmin();
  }


  permissionExecuteLoad() {
    return this.isAdmin() || this.isComplianceManager() || (this.isCompliance() && this.bankTransferLoad.amountToLoad <= 10);
  }

  permissionRequestDocs() {
    return this.isAdmin() || this.isComplianceOrFinance();
  }

  permissionRequestPoa() {
    return this.isAdmin() || this.isComplianceOrFinance();
  }

  permissionRequestIdent() {
    return this.isAdmin() || this.isComplianceOrFinance();
  }

  permissionHoldLoad() {
    return this.isAdmin() || this.isComplianceOrFinance();
  }

  permissionApproveLoad() {
    return this.isAdmin() || this.isComplianceOrFinance();
  }

  permissionDeclineLoad() {
    return this.isAdmin() || this.isComplianceOrFinance();
  }


  requestIdent() {
    this._toastService.warn("please request at customer overview");
    return false;
  }

  last4(maskedPan: string) {
    if (!maskedPan) {
      return "";
    }
    if (maskedPan.length === 4) {
      return maskedPan;
    }
    if (maskedPan.length > 4) {
      return maskedPan.substring(maskedPan.length - 4, maskedPan.length);
    }
  }

  protected readonly GpsCardStatus = GpsCardStatus;

  onSelectGraph($event: any) {

  }

  private generateLoadTimelineGraphData() {

    var newMulti = [];
    this.loadTimeline.days.forEach(day => {
      day.day = moment(day.day).format("YYYY-MM-DD");
      const oh = {
        name: day.day,
        series: [
          {name: "Incoming", value: day.incomingAmount * -1},
          {name: "Loaded", value: day.loadAmount},
          {name: "Pending", value: day.pendingAmount},
          {name: "Allowed", value: day.allowedAmount},


        ]
      };
      newMulti.push(oh);
    });

    this.multi = [...newMulti];

  }

  isDelayedNow = false;
  cannotExecuteYet = false;
  loadRiskFlags = LoadRiskFlags;
  isLoadingWhiteListedBankAccounts = false;

  hasLoadRiskFlag(haystack: LoadRiskFlags, needle: LoadRiskFlags) {
    return (haystack & needle) == needle;
  }

  globallyWhiteListBankAccount() {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Globally White-List Account",
        text: "Are you sure you want to white-list this account for ALL customers?"
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result == "ok") {
          this.isBusy = true;
          this.customersService.globallyWhiteListBankAccount(this.bankTransferLoad.trustPayTransaction.counterAccountName, this.bankTransferLoad.trustPayTransaction.counterAccount || this.trustPayTransaction.counterAccountMasked).subscribe(result => {
              this.loadBankTransferLoad(this.bankTransferLoadId);
              this.recalcLoad();

            }, err => {
              this.isBusy = false;
              this.showError(err.error.message || err.error || err.message);
            }
          );
        }
      });

  }

  protected readonly LoadRiskFlags = LoadRiskFlags;
  now: moment.Moment;
}

export enum BtlSourceList {
  Pending,
  PreApproved,
  LoadHistory,
  Refund,
  RefundHistory,
  Delayed = 5,

}
